import CIMSSelect from '../..'
import { CommonSelect } from '../types'
import { useTestingLabSelectContext } from './TestingLabSelectContext'

const TestingLabSelect: React.FC<CommonSelect> = (props) => {
  const { loading, options } = useTestingLabSelectContext()
  return <CIMSSelect options={options} loading={loading} {...props} />
}

export default TestingLabSelect
